const parseNumber = (val, fallback) => {
  const num = Number(val)
  return Number.isFinite(num) ? num : fallback
}

const monthlyProPrice = parseNumber(process.env.NEXT_PUBLIC_PRO_MONTHLY_PRICE, 9.99)
const configuredAnnualDiscount = process.env.NEXT_PUBLIC_PRO_ANNUAL_DISCOUNT
// Use Stripe's billed total; the rounded monthly equivalent is only for display.
const annualProTotalPrice = parseNumber(
  process.env.NEXT_PUBLIC_PRO_ANNUAL_TOTAL_PRICE,
  71.92,
)
const annualProMonthlyPrice = Number((annualProTotalPrice / 12).toFixed(2))
const annualDiscount = parseNumber(
  configuredAnnualDiscount,
  monthlyProPrice > 0 ? Math.max(0, 1 - annualProTotalPrice / (monthlyProPrice * 12)) : 0,
)
const currency = process.env.NEXT_PUBLIC_PRO_PRICE_CURRENCY || 'USD'

const pricing = {
  freePlanPrice: 0,
  monthlyProPrice,
  annualProPrice: annualProMonthlyPrice.toFixed(2),
  annualProMonthlyPrice: annualProMonthlyPrice.toFixed(2),
  annualProTotalPrice: annualProTotalPrice.toFixed(2),
  annualDiscount,
  enterprisePrice: 'Custom',
  currency,
}

export default pricing
